type EnvVariable = "VITE_VENUE_PORTAL_API_URL";

export const getEnvVariable = (key: EnvVariable) => import.meta.env[key];
